import Dialog from 'components/Dialog'
import { useSettings } from 'components/Settings'
import lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { Form as FinalForm, FormSpy } from 'react-final-form'

import Form from './Form'

const SettingsDialog = (props) => {
  const { isOpen, close } = props

  const [currentFormValues, setCurrentFormValues] = useState()

  const { settings, updateSettings } = useSettings()

  const onClose = () => {
    updateSettings(currentFormValues)
    close()
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('settings', 'Einstellungen')}
      closeButton={i18n.t('close', 'Schliessen')}
    >
      <div className="m-n2">
        <FinalForm onSubmit={lodash.noop} subscription={{ values: true }}>
          {(formProps) => (
            <React.Fragment>
              <FormSpy
                subscription={{ values: true }}
                onChange={({ values }) => setCurrentFormValues(values)}
              />
              <Form {...formProps} settings={settings} />
            </React.Fragment>
          )}
        </FinalForm>
      </div>
    </Dialog>
  )
}

export default SettingsDialog
